<template>
  <portlet
          :icon="'fad fa-clock'"
          :title="'Document details'"
          :actionsBlock="true"
  >
    <template slot="portletBody">
       <datatables
        v-if="documents.length && renderedComponent && Can(rights.USER_VIEW)"
        :tableClass="tableClass"
        tableID="documents"
        :rows="documents"
        :columns="getColumns()"
        :tableInitOptions="tableInitOptions"
        routerLinkClass="dt-router-link"
        :deleteFunction="deleteUser"
        deleteClass="delete"
        :customFilters="customFilters"
        @rowSelected="rowSelected"
      ></datatables>
       <edit-user
        v-if="user"
        :title="'Edit User'"
        :user="user"
        :name="'user-'+modalId"
        :roles="getRoles"
        @saveChanges="editUser($event)"
      >
      </edit-user>
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {dataTables} from '../../components/mixins/dataTables.js';
  import {swalModals} from '../../components/mixins/swalModals.js';
  import Vue from 'vue';
  import store from '../../store.js';
  import editUser from '../../components/users/editUser.vue';
  import firebase from 'firebase/app';
  import { Can } from '../../../permission/ability.js';
  import { RIGHTS } from '../roles/rights';

  export default {
  components: { editUser },
    mixins: [dataTables, swalModals],
    data() {
      return {
        rights: '',
        isAdmin: false,
        documents: [],
        categories: [],
        user: null,
        nextPageToken: null,
        customFilters: [],
        modalId: null,
      };
    },
  async   created() {
      this.rights = RIGHTS;
      this.$store.commit('setLoading',true)
     await  this.fetchData();
      this.$store.commit('setLoading',false)
      this.isAdmin = this.$store.state.users.me.admin;
    },
    methods: {
      Can,
      async  fetchData() {
        this.$store.commit('setLoading',true)
        await   store.dispatch('documents/getCategories', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments}).then((res) => {
          if (res.status === 200) {
            this.categories = res.data.data;
            this.nextPageToken = res.nextToken;
          }
        }).catch((err) => {

        });

        await   store.dispatch('documents/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments}).then((res) => {
          if (res.status === 200) {
            let documents = res.data.data
            let employmentDocs = []

            // let's count documents per employment
            let documentLine = []
            documents.map((document, key) => {
                // Index by employment id
                if(employmentDocs[document.employment.id] === undefined) {
                    employmentDocs[document.employment.id] = {
                        name: document.employment.flexworker,
                        category: {},
                        amount: 0,
                        id: document.id
                    }
                }
                // Count the documents per category
                if(employmentDocs[document.employment.id]['category'][document.category.name] === undefined) {
                    employmentDocs[document.employment.id]['category'][document.category.name] = 0
                }
                employmentDocs[document.employment.id]['category'][document.category.name]++
            })

            // Prepare the data to be sent to the view
            employmentDocs.map((document, key) => {
                for (const [documentCategory, key2] of Object.entries(document['category'])) {
                    documentLine.push({...document, amount: key2, category: documentCategory})
                }
            })

            this.documents = documentLine;
            this.nextPageToken = res.nextToken;
          }
        }).catch((err) => {

        });

          this.$store.commit('setLoading',false)
      },
      rowSelected(value) {
          this.modalId = value.id;
          this.user = value;
      },
      editUser(user) {
        if (user.email) {
            let id = user.id;
            let updatedUser = {
                firstname: user.firstname,  
                lastname: user.lastname,
                mobile: user.mobile,
                email: user.email,
                roles: user.roles,
                departments: user.departments,
            }

            var db = firebase.firestore();

            db.collection("UserData").where("id", "==", id).get().then((results) => {
              db.collection("UserData").doc(results.docs[0].id).update(updatedUser).then(() => {
                this.$toasted.global.successRequest({
                  message: 'Gebruiker aangepast',
                });
                $('.modal').modal('hide');
                $('.modal-backdrop').remove();
              }).catch((error) => {
                this.$toasted.global.failedRequest({
                  message: 'Something went wrong',
                });
                $('.modal').modal('hide');
                $('.modal-backdrop').remove();
              });
            }).catch((error) => {
              this.$toasted.global.failedRequest({
                message: 'Something went wrong',
              });
              $('.modal').modal('hide');
              $('.modal-backdrop').remove();
            });
            

            this.renderComponent();
        }
      },
      deleteUser(user) {
        store.dispatch('users/deleteUser', {ApiClient: Vue.prototype.$ApiClient, user: user}).then((res) => {
          this.$toasted.global.successRequest({
            message: 'Gebruiker verwijderd'
          });
          this.fetchData();
          this.user = {};
        }).catch((err) => {
          this.$toasted.global.failedRequest();
        });
      },
      getColumns() {
        let self = this;
        return [
          {data: 'id', name: 'Id', visible: false},
          {data: 'name', name: 'Name', visible: true, searchable: true},
          {data: 'category', name: 'Category', visible: true, searchable: true},
          {data: 'amount', name: 'Amount', visible: true, searchable: true},
        ]
      }
    },
    computed: {
      ...mapGetters('roles', ['getRoles']),
    },
  };
</script>
